const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchFranchiseDropdown = () => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );

  return axiosInstance.get(EndPoints.Franchise.LIST, {
    params: {
      limit: 1000,
      zone_id,
      f_franchise_id,
      f_is_super_franchise,
      f_is_franchise_employee,
    },
  });
};

export const fetchOnlyParentFranchiseDropdown = () => {
  const f_is_franchise_employee = Number(
    localStorage.getItem("is_franchise_employee")
  );
  const f_franchise_id = Number(localStorage.getItem("franchise_id"));
  const f_is_super_franchise = Number(
    localStorage.getItem("is_super_franchise")
  );

  return axiosInstance.get(EndPoints.Franchise.ONLY_PARENT_FRANCHISE_LIST, {
    params: {
      limit: 1000,
      zone_id,
      f_franchise_id,
      f_is_super_franchise,
      f_is_franchise_employee,
    },
  });
};

export const fetchCommentName = (payload) => {
  return axiosInstance.get(
    `${EndPoints.INVESTIGATION_COMMENT.LIST}/${payload?.investigation_id}`
  );
};

export const fetchInvestigationTemplate = (payload) => {
  return axiosInstance.get(
    `${EndPoints.INVESTIGATIONTEMPLATE.LIST_BY_ID}/${payload?.investigation_id}`
  );
};

export const fetchFranchiseDropdownDD = (payload) => {
  const params = {
    limit: 1000,
    // zone_id: Number(payload?.zone_id),
    ...(payload?.zone_id !== undefined && {
      zone_id: Number(payload?.zone_id),
    }),
    all_zone_franchise: payload?.all_zone_franchise,
    f_is_franchise_employee: Number(
      payload.is_franchise_employee
        ? payload.is_franchise_employee
        : localStorage.getItem("is_franchise_employee")
    ),
    f_franchise_id: Number(
      payload?.franchise_id
        ? payload?.franchise_id
        : localStorage.getItem("franchise_id")
    ),
    f_is_super_franchise: Number(
      payload?.is_super_franchise
        ? payload?.is_super_franchise
        : localStorage.getItem("is_super_franchise")
    ),
  };
  return axiosInstance.get(EndPoints.Franchise.LIST_DD, { params });
};

export const fetchStateByCountry = (country_code = "IN") => {
  return axiosInstance.get(`${EndPoints.STATEBYCOUNTRY}${country_code}`);
};

export const fetchZones = () => {
  return axiosInstance.get(EndPoints.ZONELIST, {
    params: {
      zone_id,
    },
  });
};

export const fetchZonesDD = (payload) => {
  const params = {
    zone_id,
    f_is_franchise_employee: Number(
      payload.is_franchise_employee
        ? payload.is_franchise_employee
        : localStorage.getItem("is_franchise_employee")
    ),
    f_franchise_id: Number(
      payload?.franchise_id
        ? payload?.franchise_id
        : localStorage.getItem("franchise_id")
    ),
    f_is_super_franchise: Number(
      payload?.is_super_franchise
        ? payload?.is_super_franchise
        : localStorage.getItem("is_super_franchise")
    ),
  };

  return axiosInstance.get(EndPoints.ZONELISTDD, {
    params,
  });
};

export const fetchDepartments = () => {
  return axiosInstance.get(EndPoints.GETDEPARTMENT, {
    params: {
      zone_id,
    },
  });
};

export const fetchEmployeeTypes = () => {
  return axiosInstance.get(EndPoints.EMPLOYEETYPE.LIST, {
    params: {
      zone_id,
    },
  });
};

export const fetchBranch = () => {
  return axiosInstance.get(EndPoints.BRANCH.LIST, {
    params: {
      zone_id,
    },
  });
};

export const fetchDesignation = () => {
  return axiosInstance.get(EndPoints.DESIGNATION.LIST, {
    params: {
      zone_id,
    },
  });
};

export const fetchDepartmentType = () => {
  return axiosInstance.get(EndPoints.DepartmentType.LIST, {
    params: {
      zone_id,
    },
  });
};

export const fetchLabDepartment = () => {
  return axiosInstance.get(EndPoints.LabDepartment.LIST, {
    params: {
      limit: 1000,
      zone_id,
    },
  });
};

export const fetchLabDepartmentDD = (payload) => {
  const params = {
    limit: 1000,
    zone_id,
    f_is_franchise_employee: Number(
      payload.is_franchise_employee
        ? payload.is_franchise_employee
        : localStorage.getItem("is_franchise_employee")
    ),
    f_franchise_id: Number(
      payload?.franchise_id
        ? payload?.franchise_id
        : localStorage.getItem("franchise_id")
    ),
    f_is_super_franchise: Number(
      payload?.is_super_franchise
        ? payload?.is_super_franchise
        : localStorage.getItem("is_super_franchise")
    ),
  };

  return axiosInstance.get(EndPoints.LabDepartment.LIST, {
    params,
  });
};

export const fetchSampleStatusList = () => {
  return axiosInstance.get(EndPoints.SAMPLESTATUS, {
    params: {
      zone_id,
    },
  });
};

export const fetchSampleType = () => {
  return axiosInstance.get(EndPoints.SAMPLETYPE.LIST, {
    params: {
      limit: 1000,
      zone_id,
    },
  });
};

export const fetchRejectionReason = () => {
  return axiosInstance.get(EndPoints.SAMPLEREJECTIONREASON.LIST, {
    params: {
      limit: 1000,
      zone_id,
    },
  });
};

export const fetchInvestigationTest = (payload) => {
  const params = {
    limit: 100,
    zone_id,
    f_is_franchise_employee: Number(
      payload.is_franchise_employee
        ? payload.is_franchise_employee
        : localStorage.getItem("is_franchise_employee")
    ),
    f_franchise_id: Number(
      payload?.franchise_id
        ? payload?.franchise_id
        : localStorage.getItem("franchise_id")
    ),
    f_is_super_franchise: Number(
      payload?.is_super_franchise
        ? payload?.is_super_franchise
        : localStorage.getItem("is_super_franchise")
    ),
  };

  return axiosInstance.get(EndPoints.INVESTIGATIONTEST.LIST, {
    params,
  });
};

export const fetchInvestigationMaster = (payload) => {
  console.log({ payload });
  const params = {
    limit: 2000,
    zone_id,
    lab_department_id: payload?.lab_department_id,
    f_is_franchise_employee: Number(
      payload.is_franchise_employee
        ? payload.is_franchise_employee
        : localStorage.getItem("is_franchise_employee")
    ),
    f_franchise_id: Number(
      payload?.franchise_id
        ? payload?.franchise_id
        : localStorage.getItem("franchise_id")
    ),
    f_is_super_franchise: Number(
      payload?.is_super_franchise
        ? payload?.is_super_franchise
        : localStorage.getItem("is_super_franchise")
    ),
  };

  return axiosInstance.get(EndPoints.INVESTIGATIONTEST.LIST_DD, {
    params,
  });
};

export const fetchShareType = () => {
  return axiosInstance.get(EndPoints.SHARETYPE.LIST, {
    params: {
      limit: 1000,
      zone_id,
    },
  });
};

export const fetchEmployees = () => {
  return axiosInstance.get(EndPoints.EMPLOYEE.LIST, {
    params: {
      // zone_id,
      limit: 0,
    },
  });
};

export const fetchOrganism = () => {
  return axiosInstance.get(EndPoints.Organism.LIST, {
    params: {
      zone_id,
    },
  });
};

export const fetchFranchiseType = (payload) => {
  const params = {
    zone_id,
    f_is_franchise_employee: Number(
      payload.is_franchise_employee
        ? payload.is_franchise_employee
        : localStorage.getItem("is_franchise_employee")
    ),
    f_franchise_id: Number(
      payload?.franchise_id
        ? payload?.franchise_id
        : localStorage.getItem("franchise_id")
    ),
    f_is_super_franchise: Number(
      payload?.is_super_franchise
        ? payload?.is_super_franchise
        : localStorage.getItem("is_super_franchise")
    ),
  };

  return axiosInstance.get(EndPoints.FranchiseType.LIST, {
    params,
  });
};

export const fetchPackageType = () => {
  return axiosInstance.get(EndPoints.PACKAGE.LIST, {
    params: {
      zone_id,
    },
  });
};

export const fetchCity = () => {
  return axiosInstance.get(EndPoints.City.LIST, {
    params: {
      zone_id,
    },
  });
};

export const fetchFranchise = () => {
  return axiosInstance.get(EndPoints.FranchiseType.LIST, {
    params: {
      zone_id,
    },
  });
};

export const fetchObservation = () => {
  return axiosInstance.get(EndPoints.InvestigationObservation.LIST, {
    params: {
      limit: 1000,
      zone_id,
    },
  });
};

export const fetchMultipleObservation = () => {
  return axiosInstance.get(
    EndPoints.InvestigationObservation.MULTIPLEOBSERVATIONlIST,
    {
      params: {
        limit: 500,
        zone_id,
      },
    }
  );
};

export const fetchMultipleRoles = () => {
  return axiosInstance.get(EndPoints.ROLE.LIST, {
    params: {
      limit: 500,
      zone_id,
    },
  });
};

export const fetchEmployeeCategory = () => {
  return axiosInstance.get(EndPoints.EmployeeCatergory.LIST, {
    params: {
      employee_type: "ZSM",
      zone_id,
    },
  });
};

export const fetchCollectionType = () => {
  return axiosInstance.get(EndPoints.CollectionType.LIST, {
    params: {
      zone_id,
    },
  });
};

export const fetchDoctorDegree = () => {
  return axiosInstance.get(EndPoints.DoctorsDegree.LIST, {
    params: {
      zone_id,
    },
  });
};

export const fetchDoctorSpecialization = () => {
  return axiosInstance.get(EndPoints.DoctorsSepcialization.LIST, {
    params: {
      zone_id,
    },
  });
};

export const fetchArea = () => {
  return axiosInstance.get(EndPoints.Area.LIST, {
    params: {
      zone_id,
    },
  });
};

export const fetchDoctor = (payload) => {
  const params = {
    zone_id,
    f_is_franchise_employee: Number(
      payload.is_franchise_employee
        ? payload.is_franchise_employee
        : localStorage.getItem("is_franchise_employee")
    ),
    f_franchise_id: Number(
      payload?.franchise_id
        ? payload?.franchise_id
        : localStorage.getItem("franchise_id")
    ),
    f_is_super_franchise: Number(
      payload?.is_super_franchise
        ? payload?.is_super_franchise
        : localStorage.getItem("is_super_franchise")
    ),
  };

  return axiosInstance.get(EndPoints.DOCTOR.LIST, {
    params,
  });
};

export const fetchPaymentMode = () => {
  return axiosInstance.get(EndPoints.PAYMENTMODE.LIST, {
    params: {
      zone_id,
    },
  });
};

export const fetchOutsourceLab = () => {
  return axiosInstance.get(EndPoints.OUTSOURCELAB.LIST, {
    params: {
      zone_id,
    },
  });
};

export const fetchPaymentType = () => {
  return axiosInstance.get(EndPoints.PAYMENTTYPE.LIST, {
    params: {
      zone_id,
    },
  });
};
